<!--
   Created by qing on 2020/9/1
   Des: 
-->
<template>
  <div class="upload-image-page">
    <div class="header">
      <div class="title">二维码传图</div>
      <div class="tips">上传完成图片可在电脑端查看</div>
      <div class="sub-tips">注意：电脑端页面不可关闭，否则上传图片会失效。</div>
    </div>
    <div class="image-container">
      <div
        class="image-item"
        v-for="img in imageList"
        :key="img.id">
        <van-image
          v-if="img.imgUrl"
          :src="img.imgUrl"
          radius="6"
          fit="cover">
          <template v-slot:loading>
            <van-loading
              size="30">
            </van-loading>
          </template>
        </van-image>
      </div>
    </div>
    <div class="bottom-btn">
      <van-button
        type="primary"
        size="small"
        :loading="showLoading"
        loading-text="上传图片中..."
        @click="uploadImage">
        添加
      </van-button>
    </div>
  </div>
</template>

<script>
  import {uuid} from "../RyForm/utils";

  export default {
    data() {
      return {
        nodeValueSuc: false,
        showLoading: false,
        fileInput: null,
        imageList: [],
        formId: '',
        topic: '',
        fieldId: '',
        subTable: 0,
        rowIdx: 1,
        taskId: '',
      }
    },
    created() {
      this.fileInput = document.createElement('input')
      this.fileInput.setAttribute('type', 'file')
      this.fileInput.setAttribute('accept', 'image/*')
      this.fileInput.setAttribute('multiple', true)
      this.fileInput.onchange = this.fileChange

      this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .then(res => {
          this.formId = res.formId
          this.topic = res.topic
          this.fieldId = res.fieldId
          this.subTable = res.subTable
          this.rowIdx = res.rowIdx
          this.taskId = res.taskId
          this.nodeValueSuc = true
        })
        .catch(err => {
          console.error(err)
        })
    },
    methods: {

      // file input change 事件触发
      fileChange(e) {
        const files = Array.from(e.target.files)
          .filter(file => file.type.indexOf('image/') === 0)
        const filesInfo = files.map(file => this.createFileInfo(file))
        if (files.length) {
          this.showLoading = true
          this.$RyFs.upload(files)
            .then(urlList => {
              urlList.map((url, idx) => {
                const image = new Image()
                image.src = url
                filesInfo[idx].imgUrl = url
              })
              this.imageList.push(...filesInfo)
              this.uploadImageToServer(filesInfo)
              this.showLoading = false
            })
            .catch(err => {
              console.error(err)
              this.showLoading = false
            })
            .finally(() => {
              this.fileInput.value = ''
            })
        }
      },
      uploadImage() {
        if (!this.nodeValueSuc) {
          this.$toast.fail('参数异常，请重新扫码打开页面')
          return
        }
        this.fileInput.click()
      },
      uploadImageToServer(imageList) {
        if (this.formId) {
          this.$store.dispatch('actionImageUploadQrcode', {
            formId: this.formId,
            topic: this.topic,
            fieldId: this.fieldId,
            subTable: this.subTable,
            rowIdx: this.rowIdx,
            taskId: this.taskId,
            imageList
          }).catch(console.error)
        } else {

          this.$store.dispatch('actionMixFormImageUploadQrcode', {
            topic: this.topic,
            imageList
          }).catch(console.error)

        }
      },
      createFileInfo(file) {
        return {
          imgName: file.name,
          imgSize: (file.size / 1000).toFixed(2),  // KB
          imgUrl: '',
          fileType: file.type || file.name.split('.').slice(-1)[0],
          id: uuid('IMAGE')
        }
      }
    }
  }
</script>

<style lang="less">

  .upload-image-page {
    background-color: #ffffff;
    padding: 20px;
    box-sizing: border-box;
    height: calc(100% - env(safe-area-inset-bottom));

    .header {
      height: 80px;

      .title {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .tips {
        font-size: 14px;
        color: #9F9F9F;
        margin-bottom: 10px;
      }

      .sub-tips {
        font-size: 14px;
        color: red;
      }
    }

    .image-container {
      height: calc(100% - 80px - 40px);
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding: 10px 0;

      .image-item {
        width: calc(100% / 3 - 8px);
        height: 100px;
        margin-right: 8px;
        margin-bottom: 8px;
        border-radius: 6px;
        border: 1px solid #ebedf0;

        .van-image {
          width: 100%;
          height: 100px;
        }
      }
    }

    .bottom-btn {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      .van-button {
        width: 90%;
        height: 40px;
      }
    }
  }
</style>